export type PullQuoteProps = Record<string, never>

export const PullQuote = (_props: PullQuoteProps) => (
  <section className="bg-ink text-paper py-24 px-6 border-b-4 border-ink">
    <div className="max-w-[1400px] mx-auto text-center">
      <blockquote className="font-display font-extrabold uppercase leading-[0.95] tracking-[-0.03em] text-[clamp(40px,6.5vw,108px)]">
        The best problems sort themselves out somewhere{' '}
        <span className="font-serif italic font-normal normal-case tracking-[-0.015em] text-hazard">
          between gear changes.
        </span>
      </blockquote>
      <cite className="block mt-8 font-mono not-italic font-medium text-xs uppercase tracking-[0.06em] text-paper-2">
        — Notebook · Barrington Tops · May
      </cite>
    </div>
  </section>
);
